import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import useLoan from 'hooks/useLoan';
import routes from 'resources/routes.json';

import { getCounterOffer, FIND_COUNTER_OFFER_SUCCESS } from '../../../../../store/actions/application-actions';
import { findCurrentLoan } from '../../../../../store/actions/customer-actions';
import { goToLoanRoute } from '../../../../../navigation/application-routes';

import Loading from 'components/features/loading/loading';
import { Button, Container, Typography } from 'lib-ui-react';
import useEvents from '../../../../../hooks/useEvents';

function CounterOfferInstallmentsQuantity() {
  const { dispatchCompleteEvent } = useEvents('application-customer-portal-web-page-contract-recurring-counter-offer', 'recurring-counter-offer')
  const dispatch = useDispatch();
  const { device, loan } = useLoan();

  const [loading, setLoading] = useState(false);

  function handleInstallmentsQuantityLow() {
    dispatchCompleteEvent('loan-installments-quantity-low')
    setLoading(true);
    dispatch(getCounterOffer(device, 'loan-installments-quantity', 'low', loan?.id)).then((response) => {
      if (response.type === FIND_COUNTER_OFFER_SUCCESS) {
        dispatch(findCurrentLoan(device)).then(({ payload: loan }) => {
          setLoading(false);
          sessionStorage.setItem('startProcessCounterOfferRecurrent', false);
          sessionStorage.setItem('betterConditionsFinded', response.payload ? 'true' : 'false');

          goToLoanRoute(loan, routes.LOAN_COUNTER_OFFER_PROCESS, routes.LOAN_APPLICATION_CONTRACT);
        });
      }
    });
  }

  function handleInstallmentsQuantityHigh() {
    dispatchCompleteEvent('loan-installments-quantity-high')
    setLoading(true);
    dispatch(getCounterOffer(device, 'loan-installments-quantity', 'high', loan?.id)).then((response) => {
      if (response.type === FIND_COUNTER_OFFER_SUCCESS) {
        dispatch(findCurrentLoan(device)).then(({ payload: loan }) => {
          setLoading(false);
          sessionStorage.setItem('startProcessCounterOfferRecurrent', false);
          sessionStorage.setItem('betterConditionsFinded', response.payload ? 'true' : 'false');

          goToLoanRoute(loan, routes.LOAN_COUNTER_OFFER_PROCESS, routes.LOAN_APPLICATION_CONTRACT);
        });
      }
    });
  }

  if (loading) {
    return (
      <>
        <Loading title="Aguarde um momento, por favor..." />
      </>
    );
  }

  return (
    <Container spacing={24} padding={16} height="100vh">
      <Container spacing={8}>
        <Typography type="title" size="medium" fontWeight={400} lineHeight="28px" color="#2A2B35">
          Você não gostou da <b>quantidade de parcelas?</b>
        </Typography>

        <Typography size="small" fontWeight={400} lineHeight="20px" color="#757575">
          Selecione uma opção abaixo.
        </Typography>
      </Container>

      <Container align="center" justify="center" spacing={8}>
        <Button
          id="low"
          outlined
          color="#757575"
          borderColor="#E0E0E0"
          margin="0"
          style={{ maxWidth: 'none' }}
          onClick={handleInstallmentsQuantityLow}
        >
          Poucas parcelas
        </Button>
        <Button
          id="high"
          outlined
          color="#757575"
          borderColor="#E0E0E0"
          margin="0"
          style={{ maxWidth: 'none' }}
          onClick={handleInstallmentsQuantityHigh}
        >
          Muitas parcelas
        </Button>
      </Container>
    </Container>
  );
}

export default CounterOfferInstallmentsQuantity;
